/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Fmt_4Inputs */

const en_pc_online_fmt_4 = /** @type {(inputs: Pc_Online_Fmt_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word export exists but does not keep the layout yet, and Office-to-PDF is not available. Scanned pages need Scan & OCR, which handles Latin scripts.`)
};

const zh_pc_online_fmt_4 = /** @type {(inputs: Pc_Online_Fmt_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以导出 Word，但暂时无法保留版式；暂不支持 Office 转 PDF。扫描页需要使用 Scan & OCR，目前支持拉丁字母文字。`)
};

/**
* | output |
* | --- |
* | "Word export exists but does not keep the layout yet, and Office-to-PDF is not available. Scanned pages need Scan & OCR, which handles Latin scripts." |
*
* @param {Pc_Online_Fmt_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fmt_4 = /** @type {((inputs?: Pc_Online_Fmt_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Fmt_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fmt_4(inputs)
	return zh_pc_online_fmt_4(inputs)
});
export { pc_online_fmt_4 as "pc.online.fmt.4" }